import { render } from "./ntp-servers.vue?vue&type=template&id=29ea5819"
import script from "./ntp-servers.vue?vue&type=script&lang=js"
export * from "./ntp-servers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__